import { Footer } from '#components/Footer.tsx'
import { Navbar } from '#components/Navbar.tsx'

export const LoggingIn = () => (
	<>
		<Navbar />
		<main class="container">
			<article class="row justify-content-center">
				<div class="col-6">Logging in ...</div>
			</article>
		</main>
		<Footer />
	</>
)
